import type { Agent } from "./agent";
import type { Thread } from "./thread";

/**
 * An evaluator will run after an agent completes. It has the ability to request that the agent
 * continue working, reset the agent, or invoke other agents.
 *
 * Evaluators are triggered on the first non-tool-call message.
 * Evaluators can be chained, but each evaluator must be resolved first.
 * Evaluators may continue the thread, but if so, must not resolve a promise until they do.
 * Evaluators cannot be triggered twice on the same thread.
 *
 *
 * Evaluators must resolve before the agent will resolve.
 */
// export class Evaluator extends EventSource {
//   public readonly thread: Thread;
//   protected _onComplete: (result: boolean) => void;
//   protected readonly evaluatorFn?: EvaluatorFn;

//   constructor({ thread, onComplete, evaluatorFn }: EvaluatorProps) {
//     super();
//     this.thread = thread;
//     this._onComplete = onComplete;
//     this.evaluatorFn = evaluatorFn;
//     this.forwardEvents(thread);
//   }

//   evaluate(onComplete?: (result: boolean) => void): void {
//     if (onComplete) {
//       this._onComplete = onComplete;
//     }
//     if (this.evaluatorFn) {
//       this.evaluatorFn(
//         {
//           thread: this.thread,
//           evaluator: this,
//         },
//         (result: boolean) => {
//           this.complete(result);
//         }
//       );
//     } else {
//       throw new Error("Evaluator function not provided");
//     }
//   }

//   protected complete(result: boolean) {
//     this._onComplete?.(result);
//   }
// }

export function makeEvaluator(fn: Evaluator): Evaluator {
  return fn;
}

export type Evaluator = (props: {
  thread: Thread;
  agent: Agent;
  complete: (result: boolean) => void;
}) => (() => void) | undefined;
